// extracted by mini-css-extract-plugin
module.exports = {"popupcontainer":"Popup_popupcontainer__1eAsl","popupcontentcontainer":"Popup_popupcontentcontainer__2sqTk"};